import { render, staticRenderFns } from "./ShopTableRow.vue?vue&type=template&id=6127c21f&"
import script from "./ShopTableRow.vue?vue&type=script&lang=js&"
export * from "./ShopTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports